import { useEffect, useState } from "react";
import Loading from "../../atoms/loading";
import NewSerial from "../../serials/registerSerials/newSerial";
import Serial from "../../serials/registerSerials/serial";
import Button from "../../atoms/button";
import { useNavigate } from "react-router-dom";
import CopyIcon from "../../../img/copyIcon";
import { statusFlow } from "../../utils/allProductStatus";
import { getOrderAdapter } from "../../orders/orderAdapters";
import ExtendedArtItemRow from "../../extendedArt/ExtendedArtItemRow";
import AddExtendedArtItem from "../../extendedArt/AddExtendedArtItem";

const gradingAdapter = getOrderAdapter("grading");

const ProductSerials = ({ user, productData, setProductData, adapter = gradingAdapter }) => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [productSerials, setProductSerials] = useState([]);
    const [adding, setAdding] = useState(false);
    const isExtended = adapter.capabilities.itemKind === "extended_art";

    useEffect(() => {
        doGetProductSerials();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setProductData(pd => { return { ...pd, serials: productSerials } });
        // eslint-disable-next-line
    }, [productSerials]);

    const doGetProductSerials = async () => {
        if (!productData) {
            return null;
        }
        setLoading(true);
        const data = await adapter.items.list(user?.token, productData);
        if (data?.type !== "success") {
            setLoading(false);
            return null;
        }
        setProductSerials(data.data);
        setLoading(false);
    }

    const goToTagGenerator = () => {
        navigate("/manafix/serials/tags", { state: adapter.items.tagsNavigation(productData) });
    }

    const getStatusIndex = () => {
        if (!statusFlow?.[productData?.delivery]) {
            return false;
        }
        const gradedIndex = Object?.keys(statusFlow?.[productData?.delivery])?.indexOf("GRADED");
        const currentIndex = Object?.keys(statusFlow?.[productData?.delivery])?.indexOf(productData?.status);
        return currentIndex >= gradedIndex;
    }

    const copyGradesToClipboard = () => {
        const gradesString = adapter.items.copyText(productSerials, productData);
        navigator.clipboard.writeText(gradesString);
    }


    if (loading) {
        return (
            <div className="m-4 border border-[#666] p-2">
                <div className="w-fit m-auto">
                    <Loading />
                </div>
            </div>
        )
    }
    return (
        <div className="m-4 border border-[#666] p-2 bg-monao relative">
            {
                getStatusIndex() ?
                    <div onClick={copyGradesToClipboard} className="absolute top-2 left-2 cursor-pointer" title="Copiar notas"><CopyIcon fill="#d59106" /></div>
                    : null
            }
            <h2 className="text-center text-lg mb-0">{adapter.itemsTitle}</h2>
            <Button classes="bg-purple-300 hover:bg-purple-500 disabled:bg-[#777] absolute top-2 right-1" disabled={!adapter.items.canGenerateTags(productSerials, productData)} click={goToTagGenerator}>Gerar etiquetas</Button>
            <h3 className="mt-0 mb-4 text-center text-sm">Cadastrados: {productSerials?.length || 0}/{productData?.numberOfCards}</h3>
            {
                productSerials?.length < productData?.numberOfCards ?
                    isExtended ?
                        <div className="w-fit m-auto mb-4">
                            <Button classes="bg-green-300 hover:bg-green-400" click={() => setAdding(true)}>Adicionar item</Button>
                        </div>
                        :
                        <NewSerial product={productData} user={user} refresh={doGetProductSerials} />
                    : null
            }
            <div className="max-h-[400px] overflow-y-scroll">
                {
                    productSerials?.map((s, i) => (
                        isExtended ?
                            <ExtendedArtItemRow user={user} item={s} order={productData} index={i} key={s?._id || i} refresh={doGetProductSerials} />
                            :
                            <Serial user={user} serial={s} product={productData} index={i} key={i} refresh={doGetProductSerials} setProductSerials={setProductSerials} />
                    ))
                }
            </div>
            {
                adding ?
                    <AddExtendedArtItem
                        user={user}
                        order={productData}
                        onAdded={() => { setAdding(false); doGetProductSerials(); }}
                        onClose={() => setAdding(false)}
                    />
                    : null
            }
        </div>
    )
}

export default ProductSerials;
